import { render, staticRenderFns } from "./RenovacionRapidaComponent.vue?vue&type=template&id=6530fa6c&scoped=true"
import script from "./RenovacionRapidaComponent.vue?vue&type=script&lang=js"
export * from "./RenovacionRapidaComponent.vue?vue&type=script&lang=js"
import style0 from "./RenovacionRapidaComponent.vue?vue&type=style&index=0&id=6530fa6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6530fa6c",
  null
  
)

export default component.exports